import moment from 'moment-timezone';

export const SALES_STATUS = {
    onSaleNow: 'onSaleNow',
    notOnSale: 'notOnSale',
    soldOut: 'soldOut',
};

const PRODUCT_TYPES = {
    admission: 1,
    addon: 2,
};

export const FILTER_CATEGORY = {
    ticketType: 'ticketType',
    salesStatus: 'salesStatus',
};

export const PRODUCT_FILTER_CATEGORIES = [
    { value: FILTER_CATEGORY.ticketType, label: 'Ticket Type' },
    { value: FILTER_CATEGORY.salesStatus, label: 'Sales Status' },
];

export const PRODUCT_FILTERS = [
    {
        value: 'all',
        label: 'All',
        menuLabel: 'All Tickets',
        category: FILTER_CATEGORY.ticketType,
    },
    {
        value: 'admission',
        label: 'Admission',
        menuLabel: 'Admission Tickets',
        category: FILTER_CATEGORY.ticketType,
        productType: PRODUCT_TYPES.admission,
    },
    {
        value: 'addon',
        label: 'Add-ons',
        menuLabel: 'Add-On Tickets',
        category: FILTER_CATEGORY.ticketType,
        productType: PRODUCT_TYPES.addon,
    },
    {
        value: 'bundles',
        label: 'Bundles',
        menuLabel: 'Bundles',
        category: FILTER_CATEGORY.ticketType,
    },
    {
        value: SALES_STATUS.onSaleNow,
        label: 'On Sale',
        menuLabel: 'On Sale Now',
        category: FILTER_CATEGORY.salesStatus,
    },
    {
        value: SALES_STATUS.notOnSale,
        label: 'Not on Sale',
        menuLabel: 'Not On Sale',
        category: FILTER_CATEGORY.salesStatus,
    },
    {
        value: SALES_STATUS.soldOut,
        label: 'Sold Out',
        menuLabel: 'Sold Out',
        category: FILTER_CATEGORY.salesStatus,
    },
];

const defaultFilter = PRODUCT_FILTERS[0];

export function getSalesStatus(item, timezone, now = moment()) {
    const saleStart = item.sale_start_date ? moment(item.sale_start_date).tz(timezone, true) : null;
    const saleEnd = item.sale_end_date ? moment(item.sale_end_date).tz(timezone, true) : null;

    if (!saleStart || !saleEnd) {
        return null;
    }

    if (item.qty_left <= 0) {
        return SALES_STATUS.soldOut;
    }

    if (saleStart > now || saleEnd < now) {
        return SALES_STATUS.notOnSale;
    }

    return SALES_STATUS.onSaleNow;
}

export function getProductFilter(value) {
    return PRODUCT_FILTERS.find((filter) => filter.value === value) ?? defaultFilter;
}

export function matchesProductFilter(product, selectedFilter, timezone) {
    const filter = getProductFilter(selectedFilter?.value);

    if (filter.category === FILTER_CATEGORY.salesStatus) {
        return getSalesStatus(product, timezone) === filter.value;
    }

    return !filter.productType || product.prod_type_id === filter.productType;
}

export function matchesBundleFilter(bundle, selectedFilter, timezone) {
    const filter = getProductFilter(selectedFilter?.value);

    if (filter.category === FILTER_CATEGORY.salesStatus) {
        return getSalesStatus(bundle, timezone) === filter.value;
    }

    return filter.value === 'all' || filter.value === 'bundles';
}

export function shouldShowProductType(productType, selectedFilter) {
    const filter = getProductFilter(selectedFilter?.value);

    if (filter.category !== FILTER_CATEGORY.ticketType) {
        return true;
    }

    return filter.productType === productType || filter.value === 'all';
}

export function shouldShowProductList(selectedFilter) {
    return getProductFilter(selectedFilter?.value).value !== 'bundles';
}

export function shouldShowBundleList(selectedFilter) {
    const filter = getProductFilter(selectedFilter?.value);

    return filter.category === FILTER_CATEGORY.salesStatus ||
        filter.value === 'all' ||
        filter.value === 'bundles';
}
